import { Team } from '../modules/context/ApplicationContext/applicationContext.types';
import { formatCompleteName } from '../utils/formatters';
import { Option } from './OptionsLib';

export interface SignatureInfo {
  name?: string | null;
  role?: string | null;
  email?: string | null;
  phone?: string | null;
  countryCode?: string | null;
  avatar?: string | null;
  editable?: boolean;
}

export const team2Signature = (
  team: Team,
  editable: boolean,
  positionTranslator: Option[],
): SignatureInfo => {
  const roleTranslator = positionTranslator.find((item) => item.value === team.position) || {
    label: undefined,
  };
  const signature = {
    name: formatCompleteName(team.name, team.surname),
    role: roleTranslator?.label,
    email: team.email,
    phone: team.phone,
    countryCode: team.countryCode,
    avatar: team.profileUrl,
    editable,
  };

  return signature;
};
